module.exports = __webpack_public_path__ + "static/media/add_prod.e9247628.svg";